/**
 * Cross-tab auth propagation. Logging out in one tab must log out every other
 * tab, and logging in must let a waiting tab continue.
 */

const CHANNEL_NAME = "invoice-manager-auth";

const supportsBroadcast = typeof window !== "undefined" && "BroadcastChannel" in window;

export function broadcastAuthChange(status) {
  if (!supportsBroadcast) return;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage(status);
  channel.close();
}

/**
 * @param {(status: "loggedIn" | "loggedOut") => void} onChange
 * @returns {() => void} cleanup
 */
export function subscribeToAuthChanges(onChange) {
  if (!supportsBroadcast) return () => {};

  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (message) => {
    if (message?.data === "loggedIn" || message?.data === "loggedOut") {
      onChange(message.data);
    }
  };

  return () => channel.close();
}
